export default __webpack_public_path__ + "static/media/admin-faq.61c342b8.svg";